// extracted by mini-css-extract-plugin
module.exports = {"c-flex-row-con":"_2b1RZmZ0dtaHgaBIJYMgd2"};